// src/telemetry/SessionCorrelation.ts
let currentCorrelationId;
// Stable per-tab session id: generated once at load and reused for the tab's
// lifetime (NOT regenerated per prompt like correlationId), so all events in a
// single DA session can be joined together.
let currentSessionId;
export function setCorrelationId(id) {
    clearCorrelationId();
    currentCorrelationId = id || currentCorrelationId;
}
export function getCorrelationId() {
    return currentCorrelationId;
}
export function clearCorrelationId() {
    currentCorrelationId = undefined;
}
export function setSessionId(id) {
    // Set once per tab load to keep the id stable; ignore later calls (e.g. a
    // remount) so session-level joins aren't broken. Use resetSessionId to force a new one.
    if (id && !currentSessionId) {
        currentSessionId = id;
    }
}
export function resetSessionId(id) {
    currentSessionId = id || undefined;
}
export function getSessionId() {
    return currentSessionId;
}
// Session-lifecycle signals for the "ready but no prompt" case (Scenario D).
// promptCount counts prompts submitted in this tab's session; sessionReadyEmitted
// guards the one-time session_ready signal. Both reset only on a fresh tab load.
let sessionReadyEmitted = false;
let promptCount = 0;
export function markSessionReadyOnce() {
    if (sessionReadyEmitted)
        return false;
    sessionReadyEmitted = true;
    return true;
}
export function isSessionReady() {
    return sessionReadyEmitted;
}
export function incrementPromptCount() {
    promptCount += 1;
}
export function getPromptCount() {
    return promptCount;
}
